import React from 'react';
import { useTranslation } from 'react-i18next';
import { useInstance } from 'react-ioc';
import { GroupOutlined, HeartOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { useCompaniesQuery, useEpicsQuery, useTeamQuery } from 'generated/graphql';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { Store } from 'model/store/Store';

import { Filter } from 'components/Filter/Filter';

import cls from './Filters.module.scss'

interface IFilters {
  selectedGroups: string[] | null;
  selectedClients: string[] | null;
  selectedTeam: string[] | null;
  selectedSearch?: string | null;
  onChangeGroups: (data: string[] | null) => void;
  onChangeClients: (data: string[] | null) => void;
  onChangeTeam: (data: string[] | null) => void;
  onChangeSearch?: (data: string | null) => void;
}

export const Filters = observer(({ onChangeSearch, selectedSearch, selectedGroups, selectedClients, selectedTeam, onChangeGroups, onChangeTeam, onChangeClients }: IFilters) => {

  const { t } = useTranslation();
  const store = useInstance(Store);


  const groups = useEpicsQuery({
    variables: {
      filters: {
        domain: {id: {eq: store.domain.selectedDomain}},
      },
      pagination: { limit: 100 }
    }
  });

  const clients = useCompaniesQuery({
    variables: {
      filters: {
        enabled: {eq: true},
        domain: {id: {eq: store.domain.selectedDomain}},
      },
      pagination: { limit: 100 },
    }
  })

  const team = useTeamQuery({
    variables: {
      domain: store.domain.selectedDomain!
    }
  })

  const groupsData =  _.map(groups.data?.epics?.data, item => ({id: item.id!, name: item.attributes?.name!}))
  const clientsData =  _.map(clients.data?.companies?.data, item => ({id: item.id!, name: item.attributes?.name!}))
  const teamData =  _.map(team.data?.team?.data, item => ({id: item.id!, name: item.username!}))

  const onGroupChanges = (data: string[]|null) => {
    onChangeGroups(data)
  }
  const onClientsChanges = (data: string[]|null) => {
    onChangeClients(data)
  }
  const onTeamChanges = (data: string[]|null) => {
    onChangeTeam(data)
  }

  return (
    <>
      {
        selectedSearch !== undefined &&
          <Input
              value={selectedSearch!}
              onChange={(e) => onChangeSearch ? onChangeSearch(e.target.value) : undefined}
              suffix={<SearchOutlined/>}
              className={cls.search}
          />
      }
      <Filter icon={<HeartOutlined/>} title={t('Client')} data={clientsData} selected={selectedClients || []} onChance={onClientsChanges}/>
      <Filter icon={<UserOutlined/>} title={t('Team')} data={teamData} selected={selectedTeam || []} onChance={onTeamChanges}/>
      <Filter icon={<GroupOutlined/>} title={t('Group')} data={groupsData} selected={selectedGroups || []} onChance={onGroupChanges}/>
    </>
  );
})